<template>
  <div class="row m-0">
    <div class="col-12 py-1 pt-2 menu_item" @click="goTo('profile')">
      <div class="row m-0 align-items-center">
        <div class="col-auto p-0 d-none d-md-flex">
          <ios-contact-icon />
        </div>
        <div class="col pe-md-0">
          <div class="row m-0 w-100">
            <div class="col-12 p-0">
              Profile
            </div>
            <div class="col-12 p-0 d-none d-md-flex small truncate" v-if="user">
              {{user.email}}
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="col-12 py-1 menu_item" @click="goTo('settings')">
      <div class="row m-0 align-items-center">
        <div class="col-auto p-0 d-none d-md-flex">
          <ios-cog-icon />
        </div>
        <div class="col pe-md-0">
          Settings
        </div>
      </div>
    </div> -->
    <div class="col-12 py-1 menu_item" @click="help()">
      <div class="row m-0 align-items-center">
        <div class="col-auto p-0 d-none d-md-flex">
          <ios-help-circle-outline-icon />
        </div>
        <div class="col pe-md-0">
          Help
        </div>
      </div>
    </div>
    <div class="col-12 py-1 pb-2 menu_item border-0" @click="logoutAndClose">
      <div class="row m-0 align-items-center">
        <div class="col-auto p-0 d-none d-md-flex">
          <ios-log-out-icon />
        </div>
        <div class="col pe-md-0">
          Logout
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
export default {
  props: ['user'],
  methods: {
    ...mapActions(['fullLogout']),
    logoutAndClose () {
      this.$emit('close')
      this.fullLogout()
    },
    help () {
      window.open('https://www.rememberblue.com/help')
    },
    goTo (val) {
      window.scrollTo(0, 0)
      this.$emit('close')
      this.$router.push(val)
    }
  }
}
</script>

<style scoped>
  .ion {
    font-size: 20px;
    /* padding-top: 0.2rem; */
  }
</style>
